import { atom } from "recoil";
import { EntityDTO, FileDTO, OrderDTO, ServiceOfferLevelDTO } from "TaxAnalyticsHelpers/TaxAnalyticsClient";
import { OrderSelect, OrderForm, OrderUploads, OrderSummary } from "TaxAnalyticsComponents/pages/order/";
import { DeloitteStep } from 'TaxAnalyticsUI/Deloitte/DeloitteStepper';
import { FlattenedOffers } from 'TaxAnalyticsComponents/mock/Offers';
import { IOffer } from 'TaxAnalyticsComponents/mock/types';

interface IOrderMessage {
    type: "info" | "warning" | "error",
    message: string
}

interface IServiceOfferState {
    offerName?: string;
    title?: string;
    currentStep: number;
    selectedLevel?: ServiceOfferLevelDTO;
    steps: DeloitteStep[];
    offer?: IOffer;
}

const getSteps = (offer?: IOffer): DeloitteStep[] => {
    if (!offer)
        return [];
    let steps: DeloitteStep[] = [];
    let stepCount = 0;
    if (offer.offerLevels && offer.offerLevels.length > 0)
        steps.push({ label: 'Choix de l\'offre', step: stepCount++, component: <OrderSelect /> });
    steps.push({ label: 'Entité', step: stepCount++, component: <OrderForm /> });
    steps.push({ label: 'Fichiers', step: stepCount++, component: <OrderUploads /> });
    steps.push({ label: 'Confirmation', step: stepCount++, component: <OrderSummary /> });
    return steps;
};

export const currentOrderReference = atom({
    key: "currentOrderReference",
    default: ""
})
export const currentServiceOfferName = atom({
    key: "currentServiceOfferName",
    default: ""
})

const orderState = atom<OrderDTO | null>({
    key: 'orderState',
    default: null
})
export const currentEntityState = atom<EntityDTO | null>({
    key: 'entityState',
    default: null
})
export const entitiesState = atom<EntityDTO[] | null>({
    key: 'entitiesState',
    default: []
})

export const filesState = atom<FileDTO[] | null>({
    key: 'filesState',
    default: []
})

export const serviceOfferStateDefault = (serviceOfferName: string, step: number, level?: ServiceOfferLevelDTO) => {
    const offer = FlattenedOffers.find(o => o.id.toLowerCase() === serviceOfferName.toLowerCase());
    const steps = getSteps(offer);
    return {
        currentStep: step,
        steps: steps,
        offer: offer,
        offerName: serviceOfferName,
        selectedLevel: level
    };
};

export const serviceOfferState = atom<IServiceOfferState>({
    key: "serviceOfferState",
    default: {
        offer: undefined,
        offerName: undefined,
        steps: [],
        title: undefined,
        currentStep: 0,
        selectedLevel: undefined
    }
});

export const currentOrderMessagesState = atom<IOrderMessage[]>({
    key: "orderMessagesState",
    default: []
});

export default orderState;

